import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { WidgetsBlock } from '@modules/layout/moleculas';
import { DashboardWidgetCount } from '@modules/dashboard/organisms';
import { useSummaryFiltersQuery, useSummaryLapsResults } from '@modules/summary-results/hooks';
import { SummaryResultsFilterRequest } from '@modules/summary-results/requests';

const Root = styled(WidgetsBlock)`
    & > div:last-child {
        grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
    }
`;

const SummaryLapsWidgets = (): React.ReactElement => {
    const { t } = useTranslation(['summary']);

    const { filters } = useSummaryFiltersQuery();
    const filter = new SummaryResultsFilterRequest(filters);

    const { summaryLapsResults, loading } = useSummaryLapsResults({
        fetchPolicy: 'network-only',
        variables: { filter },
    });

    return (
        <Root title={t('passed_laps')}>
            <DashboardWidgetCount
                label={t('summary_laps')}
                count={summaryLapsResults.allCount}
                loading={loading}
            />

            {summaryLapsResults.regionCounts.map(regionCount => (
                <DashboardWidgetCount
                    key={regionCount.regionName}
                    label={t('summary_laps_for', { regionName: regionCount.regionName })}
                    count={regionCount.count}
                    loading={loading}
                />
            ))}
        </Root>
    );
};

export { SummaryLapsWidgets };
